import React from 'react'
import styled from 'styled-components'
import { Container, Row, Col } from 'react-bootstrap'
import Particles from '../../components/Particle'
import { Title, Section, Box, LinkContact } from '../../components/Core'
//import bhHero from './tiles2.png'

const SectionStyled = styled(Section)`
    overflow: hidden;
    background: #fcfcfc;
`
// &.pattern::before {
//     position: absolute;
//     width: 100%;
//     height: 100%;
//     content: '';
//     background: url(${bhHero}) bottom center no-repeat;
//     background-size: cover;
//     z-index: -1;
// }

const Hero = ({ children, pattern = true }) => {
    return (
        <>
            <SectionStyled
                className={`position-relative ${pattern ? 'pattern' : ''}`}
            >
                <Particles />
                {children}
            </SectionStyled>
        </>
    )
}

export default Hero
